import React from 'react'
import { connect } from 'react-redux'

import BuyTokensForm from '../dashboard/buy_tokens_form'
import jsonSelector from 'selectors/json'

const Tokens = ({ abilities }) =>
  abilities.can_user_buy_tokens ? (
    <BuyTokensForm />
  ) : (
    <h2>
      The Shping Token Sale is Complete.
      <br />
      Thank you to everyone who supported us and purchased Shping Coins.
    </h2>
  )

const mapStateToProps = state => ({
  abilities: jsonSelector('infos.abilities')(state)
})

export default connect(mapStateToProps)(Tokens)



// WEBPACK FOOTER //
// ./src/containers/pages/tokens/index.js